import { Button } from '@app/components/various/Button';
import { Remove } from '@app/components/various/Icons';

interface Props {
  onClick: () => void;
}

export const RemoveButton = ({ onClick }: Props) => (
  <Button color="secondary" variant="ghost" onClick={onClick} data-testid="removeButton" icon={Remove} />
);
